import { FOOTER_MJML } from "../common/footer";

export const paymentConfirmation = `
  <mjml>
    <mj-head>
      <mj-title>Payment Confirmation | Copilotly</mj-title>
      <mj-preview>Thank you for your payment. Here's your receipt.</mj-preview>
      <mj-attributes>
        <mj-all font-family="Arial, sans-serif" />
        <mj-text font-size="16px" color="#333333" line-height="1.5" />
        <mj-section padding="0px" />
      </mj-attributes>
      <mj-style>
        .receipt-container { border-radius: 8px; overflow: hidden; }
        .payment-details { width: 100%; }
        .payment-details td { padding: 10px 0; }
        .payment-details tr { border-bottom: 1px solid #e0e0e0; }
        .payment-method-icon { vertical-align: middle; margin-right: 5px; }
        .transaction-box { border: 1px solid #e0e0e0; border-radius: 8px; padding: 15px; background-color: #f9f9f9; }
        .status-paid { background-color: #DFF3E7; color: #1F7B4D; border-radius: 4px; padding: 5px 10px; font-weight: bold; }
        @media (max-width: 480px) {
          .mobile-block { display: block !important; width: 100% !important; }
        }
      </mj-style>
    </mj-head>
    <mj-body background-color="#f5f5f5">
      <!-- Header with premium dark background -->
      <mj-section background-color="#1a2310" padding="20px 0">
        <mj-column>
          <mj-image src="https://bsauh-uae.s3.ap-south-1.amazonaws.com/bsauh-gallery-bucket/logo.png" alt="Copilotly Logo" width="200px" padding-bottom="10px" />
          <mj-text font-size="30px" color="#ffffff" font-family="Arial, sans-serif" align="center" font-weight="bold">Payment Confirmation</mj-text>
          <mj-text font-size="16px" color="#99CC66" font-family="Arial, sans-serif" align="center">Thank you for your payment</mj-text>
        </mj-column>
      </mj-section>
      
      <!-- Receipt Header -->
      <mj-section background-color="#ffffff" padding="30px 20px 20px" css-class="receipt-container">
        <mj-column>
          <mj-text font-size="22px" color="#336633" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
          <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">Thank you for your payment. We're pleased to confirm that we've received your payment successfully. Here is your receipt for your records.</mj-text>
          <mj-text font-size="16px" font-style="italic" color="#666666" font-family="Arial, sans-serif" padding-bottom="10px">"We may not live in Bihar, Jharkhand, and Uttar Pradesh, but their spirit lives in us."</mj-text>
        </mj-column>
      </mj-section>
      
      <!-- Payment Status Banner -->
      <mj-section background-color="#ffffff" padding="0px 20px" css-class="receipt-container">
        <mj-column>
          <mj-text align="center" padding-bottom="20px">
            <span class="status-paid">✓ PAYMENT SUCCESSFUL</span>
          </mj-text>
        </mj-column>
      </mj-section>
      
      <!-- Transaction Summary -->
      <mj-section background-color="#ffffff" padding="0px 20px" css-class="receipt-container">
        <mj-column>
          <mj-text font-size="18px" color="#1a2310" font-weight="bold" padding-bottom="10px">Transaction Summary</mj-text>
          
          <!-- Transaction Box -->
          <mj-text css-class="transaction-box">
            <table style="width: 100%; border-collapse: collapse;">
              <tr>
                <td style="width: 50%; padding: 5px 0; color: #777777;">Transaction ID:</td>
                <td style="width: 50%; padding: 5px 0; color: #333333; font-weight: bold; text-align: right;">TXN-{{transaction_id}}</td>
              </tr>
              <tr>
                <td style="width: 50%; padding: 5px 0; color: #777777;">Date:</td>
                <td style="width: 50%; padding: 5px 0; color: #333333; text-align: right;">{{transaction_date}}</td>
              </tr>
              <tr>
                <td style="width: 50%; padding: 5px 0; color: #777777;">Amount Paid:</td>
                <td style="width: 50%; padding: 5px 0; color: #336633; font-weight: bold; font-size: 18px; text-align: right;">AED {{amount_paid}}</td>
              </tr>
            </table>
          </mj-text>
        </mj-column>
      </mj-section>
      
      <!-- Footer Section -->
      ${FOOTER_MJML}
    </mj-body>
  </mjml>
`;

export default {
  id: "paymentConfirmation",
  name: "Payment Confirmation",
  category: "transactional",
  purpose: "transactional" as const,
  description:
    "A detailed payment receipt template with transaction details, itemized purchases, and payment method information.",
  features: [
    "Professional receipt layout",
    "Transaction details",
    "Itemized purchase summary",
    "Payment method details",
    "PDF download option",
  ],
  subject: "Payment Confirmed",
  subTitle: "Your payment has been processed",
  mjmlTemplate: paymentConfirmation,
  tags: ["transactional", "payment", "confirmation", "receipt"],
};
